import { jwtDecode } from 'jwt-decode';
import authService from '../../sdk/services/authService';
import userService from '../../sdk/services/userService';
// import MenuService from '../../sdk/services/menuService';
import type { UserModel, AppTokenModel, JoinTeamTokenModel, DynamicObjectInterface } from '../../sdk/type';
import { clearLogin } from '../../sdk/store/authActions';
import {
  REACT_APP_AMWAYID_REDIRECT_URI,
  REACT_APP_AMWAY_REDIRECT_LOG_OUT_URI,
  REACT_APP_AMWAYID_CLIENT_ID,
  REACT_APP_AMWAYID_AUTHORIZE_BASE_URL,
  REACT_APP_AMWAYID_SERVER_ID,
  REACT_APP_AMWAYID_CLIENT_APP,
} from '../../envVars';
import { LoggerService } from './logger';
import { randomStr } from './helper';

const authorizeBaseUrl = REACT_APP_AMWAYID_AUTHORIZE_BASE_URL;
const serverId = REACT_APP_AMWAYID_SERVER_ID;
const redirectUri = REACT_APP_AMWAYID_REDIRECT_URI;
const redirectLogoutUri = REACT_APP_AMWAY_REDIRECT_LOG_OUT_URI;
const clientId = REACT_APP_AMWAYID_CLIENT_ID;
const clientApp = REACT_APP_AMWAYID_CLIENT_APP;

// Not using
// export const doLogin = async (username: string, password: string) => {
//   try {
//     let res = await authService.doLogin({
//       userName: username,
//       password: password,
//     });

//     if (res.data.status) {
//       // register in localStorage
//       localStorage.setItem('appToken', res.data.token.accessToken);
//       localStorage.setItem('exp', res.data.token.exp);

//       let decoded: AppTokenModel = jwtDecode(res.data.token.accessToken);
//       localStorage.setItem('userId', JSON.stringify(decoded.userId));
//       localStorage.setItem('loginId', decoded.loginId);

//       return decoded;
//     } else {
//       LoggerService.log(res.data.message);
//       return false;
//     }
//   } catch (e) {
//     LoggerService.log('Login Error', e);
//     return false;
//   }
// };

// Not using
export const doRegister = async (user: UserModel) => {
  try {
    let res = await userService.createUser(user);

    if (res.data?.insertedId) {
      return user.userName;
    } else {
      LoggerService.log(res.data?.message);
      return false;
    }
  } catch (e) {
    LoggerService.log('Register Error', e);
    return false;
  }
};

export const doLogout = () => {
  LoggerService.log('Logout system, clear data');
  // clear localStorage
  localStorage.removeItem('appToken');
  localStorage.removeItem('loginToken');
  localStorage.removeItem('idToken');
  localStorage.removeItem('exp');
  localStorage.removeItem('userId');
  localStorage.removeItem('loginId');
  localStorage.removeItem('state');
  localStorage.removeItem('globalPartyID');
  localStorage.removeItem('pinNumber');
};

export const isTokenValid = (token: string = '') => {
  if (!token) {
    token = localStorage.getItem('appToken') || '';
  }

  if (token) {
    const decoded: AppTokenModel = jwtDecode(token);

    if (decoded?.exp) {
      return new Date().getTime() < decoded.exp * 1000;
    }
    return false;
  }
  return false;
};

export const validateToken = async (token: string = '') => {
  if (!token) {
    token = localStorage.getItem('appToken') || '';
  }

  if (token) {
    try {
      let res = await authService.validate();
      LoggerService.log(res);

      return true;
    } catch (e) {
      LoggerService.log('Register Error', e);
    }
  }
  return false;
};

export const getAccessToken = () => {
  return localStorage.getItem('appToken') ?? '';
};

export const redirectByRole = (options: {
  dispatch: Function;
  apiCall: Function;
  navigate: Function;
  source?: string | null;
  id?: string | null;
  postLoginUrl?: string | null;
  token: string;
  userInfo: AppTokenModel;
  decodedTeam?: JoinTeamTokenModel | null;
  setIsLogin: (isTrue: boolean) => void;
}) => {
  let { dispatch, navigate, source, id, postLoginUrl, token, userInfo, decodedTeam, setIsLogin } = options;
  decodedTeam = decodedTeam ?? [];

  try {
    // Validate token
    if (isTokenValid(token)) {
      // const menuDataResult = await apiCall(MenuService?.getMenu);
      if (userInfo.frameworkRole === 'MEMBER') {
        setIsLogin(true);
        if (source === 'email') {
          navigate(`/join-team?cmI=${decodedTeam[0]}&tmI=${decodedTeam[1]}&tmL=${decodedTeam[2]}`);
        } else if (source === 'createTeam') {
          navigate(`/join-team?cmI=${decodedTeam[0]}&tmI=${decodedTeam[1]}&tmL=${decodedTeam[2]}&source=createTeam`);
        } else if (id && postLoginUrl) {
          LoggerService.log(`navigating to ${postLoginUrl}?id=${id}`);
          navigate(`${postLoginUrl}?id=${id}`);
        } else if (id) {
          LoggerService.log(`navigating to ?id=${id}`);
          navigate(`?id=${id}`);
        } else if (postLoginUrl) {
          navigate(postLoginUrl !== '/' ? postLoginUrl : '/');
        } else {
          navigate(`/`);
        }
      }

      if (userInfo.frameworkRole === 'ADMIN') {
        setIsLogin(true);
        navigate('/admin');
      }
    } else {
      dispatch(clearLogin(null));
    }
  } catch (error) {
    LoggerService.log('Failed to retrieve audit history log', error);
  }
};

export const getAmwayLoginUrl = (stateObj: { [key: string]: string | null }) => {
  const RESPONSE_MODE = 'form_post';
  const RESPONSE_TYPE = 'code';
  const SCOPE =
    'openid profile bonus:all:read abo abo_name party_name email acct_subtype acct_type role mdms:uberprofile:read';

  const NONCE = randomStr(12);
  const state = { ...stateObj, amw_lng: 'en-us', amw_clientapp: clientApp };

  return `${authorizeBaseUrl}/${serverId}/v1/authorize?response_mode=${RESPONSE_MODE}&response_type=${RESPONSE_TYPE}&scope=${SCOPE}&nonce=${NONCE}&state=${btoa(
    JSON.stringify(state),
  )}&cancelredirect=${redirectLogoutUri}&redirect_uri=${redirectUri}&client_id=${clientId}`;
};

export const getAmwayLogoutUrl = () => {
  return `${authorizeBaseUrl.replace(
    '/v1/proxy/oauth2',
    '',
  )}/signout?clientapp=${clientApp}&client_id=${clientId}&redirect=${redirectLogoutUri}`;
};

export const getAmwayLogoutUrlRedirect = (redirectURL: string) => {
  return `${authorizeBaseUrl.replace(
    '/v1/proxy/oauth2',
    '',
  )}/signout?clientapp=${clientApp}&client_id=${clientId}&redirect=${redirectURL}`; 
};

export const getAmwayLogoutUrlWithoutRedirect = () => {
  return `${authorizeBaseUrl.replace('/v1/proxy/oauth2', '')}/signout?clientapp=${clientApp}&client_id=${clientId}`;
};

export const getState = async (keys: string | string[]) => {
  let state: DynamicObjectInterface = localStorage.getItem('state');
  state = state ? await JSON.parse(atob(state)) : {};
  return typeof keys === 'string' ? state[keys] : keys.map(key => state[key]);
};

export const updateState = async (...fields: [string, DynamicObjectInterface][]) => {
  let state: DynamicObjectInterface = localStorage.getItem('state');
  state = state ? await JSON.parse(atob(state)) : {};
  fields.forEach(field => {
    state[field[0]] = field[1];
  });
  localStorage.setItem('state', btoa(JSON.stringify(state)));
};

export const updateStateNew = async (fields: DynamicObjectInterface[]) => {
  let stateString = localStorage.getItem('state');
  let state: DynamicObjectInterface = stateString ? await JSON.parse(atob(stateString)) : {};

  fields.forEach((field: DynamicObjectInterface) => {
    state[field[0]] = field[1];
  });

  localStorage.setItem('state', btoa(JSON.stringify(state)));
};

export const removeState = async (keys: string | string[]) => {
  let state: DynamicObjectInterface = localStorage.getItem('state');
  state = state ? await JSON.parse(atob(state)) : {};
  if (state) {
    if (typeof keys === 'string') {
      delete state[keys];
    } else {
      keys.forEach(key => delete state[key]);
    }
  }
  localStorage.setItem('state', btoa(JSON.stringify(state)));
};

export const isUserAuthenticated = (): boolean => {
  const token = localStorage.getItem('loginToken');
  return isTokenValid(token ?? '');
};

export const isLoggedInAuthenticated = (): boolean => {
  const token = localStorage.getItem('appToken');
  return isTokenValid(token ?? '');
};

export const isLoginAttempt = (): boolean => {
  const token = localStorage.getItem('loginToken');
  const code = localStorage.getItem('code');

  return isTokenValid(token ?? '') || code ? true : false;
};
